const Loading = () => (
  <div className="loading-spinner">
    <div data-uk-spinner="ratio: 1.4;"></div>
  </div>
);

export default Loading;
